"use client";

import { WowGameMenu } from "@/components/wow/game-menu";
import { useWowMode } from "@/components/wow/wow-mode";

export function WowGate({ children }: { children: React.ReactNode }) {
  const { active } = useWowMode();

  if (active) {
    return <WowGameMenu />;
  }

  return children;
}
